import _ from 'lodash';

const CarrierType = {
  UPS: 'UPS',
  USPS: 'USPS',
  FEDEX: 'FedEx',
};

const UPS_PATTERNS = [/^1Z[0-9A-Z]{16}$/, /^T[0-9A-Z]{10}$/, /^[0-9]{9}$/, /^[0-9]{26}$/];

const USPS_PATTERNS = [
  /^(94|93|92|95)[0-9]{20}$/,
  /^(94|93|92|95)[0-9]{22}$/,
  /^(70|14|23|03)[0-9]{14}$/,
  /^(M0|82)[0-9]{8}$/,
  /^[A-Z]{2}[0-9]{9}[A-Z]{2}$/,
];

const FEDEX_PATTERNS = [/^[0-9]{12}$/, /^[0-9]{15}$/, /^[0-9]{20}$/, /^[0-9]{22}$/];

const CARRIER_PATTERNS = [
  { carrier: CarrierType.UPS, patterns: UPS_PATTERNS },
  { carrier: CarrierType.USPS, patterns: USPS_PATTERNS },
  { carrier: CarrierType.FEDEX, patterns: FEDEX_PATTERNS },
];

const TRACKING_URL_MAP = {
  [CarrierType.UPS]: trackingNumber => `https://www.ups.com/track?tracknum=${trackingNumber}`,
  [CarrierType.USPS]: trackingNumber =>
    `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`,
  [CarrierType.FEDEX]: trackingNumber =>
    `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`,
};

const detectCarrier = trackingNumber => {
  if (_.isNil(trackingNumber)) {
    return null;
  }

  const cleaned = String(trackingNumber).replace(/\s+/g, '').toUpperCase();

  if (!cleaned) {
    return null;
  }

  const match = CARRIER_PATTERNS.find(({ patterns }) =>
    patterns.some(pattern => pattern.test(cleaned)),
  );

  return match?.carrier ?? null;
};

const getTrackingUrl = (trackingNumber, carrier) => {
  if (_.isNil(trackingNumber) || _.isNil(carrier)) {
    return null;
  }

  const cleaned = String(trackingNumber).replace(/\s+/g, '');
  const urlBuilder = TRACKING_URL_MAP[carrier];

  return urlBuilder?.(cleaned) ?? null;
};

export const getTrackingInfo = trackingNumber => {
  const carrier = detectCarrier(trackingNumber);

  if (!carrier) {
    return null;
  }

  const url = getTrackingUrl(trackingNumber, carrier);

  return { carrier, url };
};
